import React from 'react';
import { Flex, Text, Heading, Image } from '@chakra-ui/core';
import { useStoreState, useStoreActions } from 'easy-peasy';

import theme, { colors } from '../../styles/theme';
import TextZjc from './TextZjc';
import MoneyManager from '../../assets/pfmicon.png';
import JointAccounts from '../../assets/jointcard-icon.png';
import { zjcWebUrl } from '../../lib/consts';

const LoginModal = () => {
  const { setShowZjc } = useStoreActions(actions => actions.modalDisplay);
  const { showZjc } = useStoreState(state => state.modalDisplay);

  return showZjc ? (
    <TextZjc />
  ) : (
    <>
      <Heading
        py={[4, 6]}
        fontSize={[theme.fontSizes[4], theme.fontSizes[6]]}
        as="h1"
        fontWeight="semibold"
        textAlign={['center', 'left']}
      >
        Choose a product to login to
      </Heading>
      <Text
        py={[3, 0]}
        fontSize={[theme.fontSizes[3], theme.fontSizes[3]]}
        as="h2"
        textAlign={['center', 'left']}
      >
        Select a product to get started:
      </Text>
      <Flex pb={[0, 3]} mb={[0, 8]} justify="space-between" wrap="wrap" mt={8}>
        <Flex
          cursor="pointer"
          onClick={() => {
            window.location.href = '/welcome';
          }}
          direction="column"
          backgroundColor={colors.shared}
          width={['100%', '48%']}
          minWidth="48%"
          borderRadius="8px"
          textAlign={['center', 'left']}
          pb={4}
        >
          <Text
            fontWeight="semibold"
            textAlign={['center', 'left']}
            fontSize={[theme.fontSizes[3], theme.fontSizes[3]]}
            pt={8}
            pl={[0, 4]}
          >
            Zeta Money Manager
          </Text>
          <Text fontWeight="500" color={colors.lightGrey} pl={[0, 4]} fontSize="14px">
            A free budgeting app <br /> designed for couples
          </Text>
          <Flex pr={[0, 4]} justify={['center', 'flex-end']} mt={[0, 6]}>
            <Image data-pin-nopin="true" src={MoneyManager} height={['8rem', '6rem']} />
          </Flex>
        </Flex>
        <Flex
          cursor="pointer"
          onClick={() => {
            setShowZjc(true);
          }}
          direction="column"
          backgroundColor={colors.partnerLighter}
          width={['100%', '48%']}
          minWidth="48%"
          borderRadius="8px"
          mt={[8, 0]}
          mb={[8, 0]}
          textAlign={['center', 'left']}
        >
          <Text
            textAlign={['center', 'left']}
            fontWeight="semibold"
            fontSize={[theme.fontSizes[3], theme.fontSizes[3]]}
            pt={8}
            pl={[0, 4]}
          >
            Zeta Joint Cards
          </Text>
          <Text color={colors.lightGrey} fontWeight="500" pl={[0, 4]} fontSize="14px">
            Shared banking <br />
            for modern couples
          </Text>
          <Flex justify={['center', 'flex-end']} mt={[0, 6]}>
            <Image data-pin-nopin="true" src={JointAccounts} height={['8rem', '6rem']} />
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default LoginModal;
